/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./Menu',
	'text!./templates/MegaMenu.html'
], function(Menu, template) {

	var MegaMenu = null;

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	MegaMenu = Menu.extend({
		templateString: template
	});

	return MegaMenu;
});
